import React, { useEffect, useRef, useState } from "react";

// Image qui apparaît en fondu une fois chargée, pour masquer le "pop"
// après les transitions de page. S'utilise comme une <img> normale.
//
// `alt` est extrait des props et passé explicitement : sinon il arrive noyé
// dans {...props} et la règle eslint jsx-a11y/alt-text ne le voit pas, ce qui
// fait échouer le build en CI. Défaut "" = image décorative.
export default function FadeImg({ style, onLoad, alt = "", ...props }) {
  const [loaded, setLoaded] = useState(false);
  const ref = useRef(null);

  useEffect(() => {
    // image déjà en cache : pas d'évènement onLoad -> on vérifie au montage
    if (ref.current && ref.current.complete && ref.current.naturalWidth > 0) {
      setLoaded(true);
    }
  }, []);

  return (
    <img
      ref={ref}
      alt={alt}
      {...props}
      onLoad={(e) => {
        setLoaded(true);
        if (onLoad) onLoad(e);
      }}
      style={{
        opacity: loaded ? 1 : 0,
        transition: "opacity 0.5s ease",
        ...style,
      }}
    />
  );
}
